(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 2231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8529);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5235);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6556);
/* harmony import */ var _components_ButtonLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4748);
/* harmony import */ var _components_Footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1127);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3621);
/* harmony import */ var _data_bots__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3402);
/* harmony import */ var _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8325);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9526);
/* harmony import */ var _utils_urls__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1256);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2903);














var Container = (0,_stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .styled */ .zo)('main', {
  paddingTop: _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .theme.space.xxl */ .rS.space.xxl,
  flex: '1 0 auto',
  displayFlex: 'column',
  width: '80vw',
  gap: _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .theme.space.xxl */ .rS.space.xxl,
  alignItems: 'stretch',
  color: _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .theme.colors.textPrimary */ .rS.colors.textPrimary,
  variants: {
    view: {
      desktop: {
        maxWidth: _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .dashboardMaxWidth */ .AA
      },
      mobile: {
        maxWidth: "calc(".concat(_utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .smallestDashboardWidth */ .EH, " - ").concat(_utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .dashboardPadding */ .SP, " * 2)")
      }
    }
  }
});
var CtaSection = (0,_stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .styled */ .zo)('div', {
  displayFlex: 'column',
  gap: _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .theme.space.xl */ .rS.space.xl,
  variants: {
    padding: {
      present: {
        paddingY: _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .theme.space.lg */ .rS.space.lg
      },
      none: {
        padding: 0
      }
    }
  }
});
var Slogan = (0,_stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .styled */ .zo)('h2', {
  fontSize: _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .theme.fontSizes.five */ .rS.fontSizes.five,
  fontWeight: _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .theme.fontWeights.bold */ .rS.fontWeights.bold
});
var CtaButtons = (0,_stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .styled */ .zo)('div', {
  display: 'flex',
  gap: _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .theme.space.lg */ .rS.space.lg,
  variants: {
    view: {
      mobile: {
        flexDirection: 'column'
      },
      desktop: {
        flexDirection: 'row',
        alignItems: 'center'
      }
    }
  }
});
var SubTitle = (0,_stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .styled */ .zo)('h3', {
  fontSize: _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .theme.fontSizes.four */ .rS.fontSizes.four,
  fontWeight: _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .theme.fontWeights.bold */ .rS.fontWeights.bold
});
var BotsList = (0,_stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .styled */ .zo)('ul', {
  display: 'grid',
  gap: _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .theme.space.xl */ .rS.space.xl,
  variants: {
    columns: {
      single: {
        gridTemplateColumns: '1fr',
        gridTemplateRows: "repeat(".concat(Object.entries(_data_bots__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).length, ", 1fr)")
      },
      "double": {
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: "repeat(".concat(Math.ceil(Object.entries(_data_bots__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).length / 2), ", 1fr)")
      }
    }
  }
});
var BotCard = (0,_stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .styled */ .zo)('a', {
  displayFlex: 'column',
  gap: _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .theme.space.md */ .rS.space.md,
  padding: _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .theme.space.lg */ .rS.space.lg,
  backgroundColor: _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .theme.colors.bgCard */ .rS.colors.bgCard,
  border: "1px solid ".concat(_stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .theme.colors.onBgSecondary */ .rS.colors.onBgSecondary),
  borderRadius: _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .theme.radii.lg */ .rS.radii.lg,
  cursor: 'pointer',
  height: '100%'
});
var BotCardHeader = (0,_stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .styled */ .zo)('div', {
  displayFlex: 'row',
  gap: _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .theme.space.xs */ .rS.space.xs,
  alignItems: 'center',
  fontSize: _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .theme.fontSizes.three */ .rS.fontSizes.three,
  fontWeight: _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .theme.fontWeights.bold */ .rS.fontWeights.bold
});
var BotLogo = (0,_stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .styled */ .zo)('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 44,
  height: 44
});
var BotDescription = (0,_stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .styled */ .zo)('div', {
  fontSize: _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .theme.fontSizes.two */ .rS.fontSizes.two,
  fontWeight: _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .theme.fontWeights.thin */ .rS.fontWeights.thin,
  maxWidth: '75%',
  color: _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .theme.colors.textSecondary */ .rS.colors.textSecondary
}); // const CustomSolutionUpsell = oldStyled.li`
// 	display: flex;
// 	flex-direction: column;
// 	justify-content: center;
// 	gap: 12px;
// 	padding: 16px;
// 	border: 1px solid ${({ theme }) => theme.colors.onBackground.secondary};
// 	border-radius: 8px;
// `;
//
// const UpsellTitle = oldStyled.span`
// 	font-size: 22px;
// 	font-weight: 550;
// `;
//
// const UpsellLink = oldStyled(Link)`
// 	color: ${({ theme }) => theme.colors.accent};
// 	font-weight: 440;
//
// 	&:hover {
// 		text-decoration: underline;
// 	}
// `;

var BotSection = (0,_stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .styled */ .zo)('div', {
  displayFlex: 'column',
  gap: _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .theme.space.lg */ .rS.space.lg
});
var DonateHeading = (0,_stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .styled */ .zo)('div', {
  gap: _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .theme.space.xxl */ .rS.space.xxl,
  justifyContent: 'space-between',
  variants: {
    direction: {
      horizontal: {
        displayFlex: 'row',
        alignItems: 'center'
      },
      vertical: {
        displayFlex: 'column',
        alignItems: 'flex-start'
      }
    }
  }
});

function Home() {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .Fragment */ .HY, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(Container, {
      view: (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
        '@initial': 'mobile'
      }, _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .config.media.dashboardMaxWidth */ .vc.media.dashboardMaxWidth, 'desktop'),
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(CtaSection, {
        padding: {
          '@initial': 'present',
          '@small': 'none'
        },
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(Slogan, {
          children: "Modern solutions for modern problems"
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(CtaButtons, {
          view: (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
            '@initial': 'mobile'
          }, _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .config.media.small */ .vc.media.small, 'desktop'),
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_components_Button__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .z, {
            as: _components_ButtonLink__WEBPACK_IMPORTED_MODULE_2__/* .ButtonLink */ .Z,
            buttonType: "callToAction",
            href: "/support",
            external: true,
            children: "Join our Discord server"
          })
        })]
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(BotSection, {
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(SubTitle, {
          children: "Our bots"
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(BotsList, {
          columns: (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
            '@initial': 'single'
          }, _stitches_stitches_config__WEBPACK_IMPORTED_MODULE_6__/* .config.media.small */ .vc.media.small, 'double'),
          children: Object.entries(_data_bots__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).map(function (_ref4) {
            var _ref5 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_ref4, 2),
                pathName = _ref5[0],
                _ref5$ = _ref5[1],
                name = _ref5$.name,
                cardDescription = _ref5$.description.card;

            var Icon = _data_bots__WEBPACK_IMPORTED_MODULE_5__/* .botIcons */ .j[pathName];
            return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("li", {
              children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
                href: _utils_urls__WEBPACK_IMPORTED_MODULE_8__/* .botPage */ .i6(pathName),
                children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(BotCard, {
                  href: _utils_urls__WEBPACK_IMPORTED_MODULE_8__/* .botPage */ .i6(pathName),
                  children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(BotCardHeader, {
                    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(BotLogo, {
                      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(Icon, {
                        width: 32,
                        height: 32
                      })
                    }), name]
                  }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(BotDescription, {
                    children: cardDescription
                  })]
                })
              })
            }, name);
          })
        })]
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(DonateHeading, {
        direction: {
          '@initial': 'vertical',
          '@small': 'horizontal'
        },
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_components_Heading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          title: "Support the project",
          subtitle: "Donate on Kofi to help support the apps we're developing."
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_components_Button__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .z, {
          as: _components_ButtonLink__WEBPACK_IMPORTED_MODULE_2__/* .ButtonLink */ .Z,
          buttonType: "callToAction",
          href: "/kofi",
          external: true,
          children: "Donate"
        })]
      })]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_components_Footer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})]
  });
}

/* harmony default export */ __webpack_exports__["default"] = (Home);

/***/ }),

/***/ 7314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(2231);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [97,385,774,888,179], function() { return __webpack_exec__(7314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);